module.exports = __webpack_public_path__ + "static/logo-e2523476d5c388367cf15d2e17790e83.png";